// @ts-nocheck
import { Dictionary } from "@insite/client-framework/Common/Types";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";

const variantNameToAttributeNameMapper: Dictionary<string> = {
    Size: "Trim (IMPRP4)",
};

const getTrimTraitValueDisplayName = (
    product: ProductModel | null | undefined,
    variantTraitName: string,
    baseValueDisplay: string,
) => {
    if (!baseValueDisplay || !product?.attributeTypes?.length || !getBooleanProperty(product.properties.isTrim)) {
        return baseValueDisplay;
    }

    const attributeName = variantNameToAttributeNameMapper[variantTraitName];

    if (!attributeName) {
        return baseValueDisplay;
    }

    const attributeType = product.attributeTypes.find(x => x.name === attributeName);
    const attributeValue = attributeType?.attributeValues?.[0];

    return attributeValue ? `${baseValueDisplay} ${attributeValue.valueDisplay}` : baseValueDisplay;
};

export default getTrimTraitValueDisplayName;
